var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CanvasColorConverter from "../../../common/neopdf/CanvasColorConverter";
export default function renderBlueprintedPdfPage(arg) {
    return __awaiter(this, void 0, void 0, function* () {
        const { pdf, pageIndex, printOption, doNotProduceImage } = arg;
        const { luminanceMaxRatio, colorConvertMode } = printOption;
        const dpi = arg.dpi ? arg.dpi : 300;
        const pdfPage = yield pdf.getPageAsync(pageIndex + 1);
        const canvasDesc = yield pdfPage.render_dpi({ cellIndexOnSheet: 0, dpi, doNotProduceImage });
        if (colorConvertMode && (!doNotProduceImage)) {
            const pdfCanvas = canvasDesc.canvas;
            const converter = new CanvasColorConverter(pdfCanvas);
            yield converter.convert(colorConvertMode, luminanceMaxRatio);
        }
        return canvasDesc;
    });
}
//# sourceMappingURL=convertPdfPageColor.js.map